export const CHECKOUT_URL = 'https://el-metodo-del-futbol.impultienda.ar/checkout'

export const urgency = {
  headline: 'SOLO PARA LOS PRIMEROS 50 PROFES',
  detail: 'Sistema completo + 5 bonos + plantilla de planificación por $24.999.',
  spotsLeft: 12,
  spotsTotal: 50,
}

export const pains: { title: string; body: string }[] = [
  {
    title: 'Llegás corriendo del laburo',
    body: 'Masticando un sándwich en el auto, para encontrarte con 20 chicos que tienen más energía que una planta nuclear.',
  },
  {
    title: 'Improvisás lo que viste en Instagram',
    body: 'A los 2 minutos los chicos están dispersos, porque el ejercicio no tiene ningún sentido para su edad.',
  },
  {
    title: 'Los gritos desde afuera',
    body: '"¡Tirala afuera!", "¡Corré!", "¡Pateá!". Los padres dirigen desde la tribuna y vos sentís que perdés el control del grupo.',
  },
  {
    title: 'Te vas a dormir frustrado',
    body: 'Sabés que tenés buenos jugadores. Lo que no lográs es que once pibes jueguen como un equipo.',
  },
]

export const dreams: { title: string; body: string }[] = [
  {
    title: 'Sabés exactamente qué hacer',
    body: 'Tenés la sesión planificada en una ficha en el celular. Tardaste 5 minutos en armarla.',
  },
  {
    title: 'Silencio en la tribuna',
    body: 'Los padres se callan porque ven que el equipo sale jugando y que el mando lo tenés vos.',
  },
  {
    title: 'Resultados que se ven',
    body: 'Los últimos 15 minutos, cuando todos se cansan, tu equipo vuela. No corren más: saben dónde pararse.',
  },
  {
    title: 'Respeto total',
    body: 'Los dirigentes ven tu orden y saben que sos un profe profesional, no uno del montón.',
  },
]

export const tomos: { tag: string; title: string; body: string }[] = [
  {
    tag: 'Tomo 01 · 02',
    title: 'Baby Fútbol',
    body: 'Cómo dominar el micro-espacio. Ejercicios de 1vs1 que fabrican cracks, no ejecutores de conos.',
  },
  {
    tag: 'Tomo 03 · 04',
    title: 'Futsal',
    body: 'El ajedrez del cemento. Salidas, rotaciones y jugadas de pizarrón que valen medio gol.',
  },
  {
    tag: 'Tomo 05 · 06',
    title: 'Fútbol 11',
    body: 'Cómo ocupar la cancha grande. El "Acordeón Defensivo" para que no te metan un gol nunca más.',
  },
]

export const bonuses: { name: string; body: string; value: string }[] = [
  {
    name: 'Padres en la tribuna',
    body: 'El contrato de convivencia para que los padres te dejen trabajar en paz.',
    value: '$45.000',
  },
  {
    name: 'Combustible de cancha',
    body: 'Nutrición simple para que los chicos no se "mueran" en el segundo tiempo.',
    value: '$35.000',
  },
  {
    name: 'Protocolo de emergencia',
    body: 'Qué hacer cuando un chico se golpea y no hay médico cerca de la cancha.',
    value: '$40.000',
  },
  {
    name: 'La mente del capitán',
    body: 'Cómo dar charlas técnicas que ericen la piel. Motivación real, no frases de póster.',
    value: '$55.000',
  },
  {
    name: 'Profe marca registrada',
    body: 'Armá tu CV y tus redes para que te vengan a buscar de clubes mejores.',
    value: '$60.000',
  },
]

export const includedToday: string[] = [
  '100 ejercicios de fútbol',
  'Ejercicios para futsal',
  'Ejercicios de fútbol 11',
  'Ejercicios para baby fútbol',
  'El Manual del Profe',
  '5 bonos de regalo',
]

export const testimonials: { quote: string; name: string; place: string }[] = [
  {
    quote:
      'Tenía el grupo descontrolado. Apliqué el sistema de grupos reducidos del manual y hoy los chicos no quieren que termine la práctica. La mejor inversión de mi carrera.',
    name: 'Profe Roberto',
    place: 'San Miguel',
  },
  {
    quote:
      'Las jugadas de lateral de Futsal son un robo. Metimos 4 goles en 2 partidos solo con eso. El manual se paga solo en la primera fecha.',
    name: 'DT Marcos',
    place: 'Rosario',
  },
]

export const faqs: { q: string; a: string }[] = [
  {
    q: '¿Es un libro físico?',
    a: 'No. Es un pack digital (PDF y videos) pensado para que lo lleves en el celular a la cancha y lo abras entre ejercicio y ejercicio.',
  },
  {
    q: '¿Sirve para nenas?',
    a: '100%. La táctica y la técnica no tienen género. El sistema se aplica igual en fútbol femenino, mixto o masculino.',
  },
  {
    q: '¿Cómo pago?',
    a: 'Con Mercado Pago: tarjeta de crédito, débito, dinero en cuenta o transferencia. El acceso llega a tu mail al instante.',
  },
  {
    q: '¿Y si no me sirve?',
    a: 'Tenés 7 días. Me mandás un WhatsApp y te devuelvo el 100%. Sin preguntas, sin formularios, sin vueltas.',
  },
]
